import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const CreateGame = () => {
  const [gameCode, setGameCode] = useState("");
  const [partnerStatus, setPartnerStatus] = useState("Waiting for partner to join...");
  const navigate = useNavigate();

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const startCheckIfPartnerJoined = (gameId) => {
    const intervalId = setInterval(async () => {
      try {
        const response = await fetch("/api/hasPartnerJoined", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ gameId }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.status === "joined") {
            clearInterval(intervalId);
            setPartnerStatus("Partner joined! Starting game...");
            await sleep(2000);
            navigate("/play");
          }
        } else {
          console.error(`Failed to check partner status. Status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error checking partner status:", error);
      }
    }, 1000);
  };

  const getNewGameId = async () => {
    if (gameCode) return; // Prevent duplicate requests

    try {
      const response = await fetch("/api/createGame");

      if (response.ok) {
        const data = await response.json();
        if (data.gameId) {
          setGameCode(data.gameId); // Set the game ID from the API response
          startCheckIfPartnerJoined(data.gameId);
        } else {
          console.error("Game ID is missing in the response.");
        }
      } else {
        console.error(`Failed to create game. Status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error creating game:", error);
    }
  };

  useEffect(() => {
    getNewGameId();
  });

  return (
    <div className="card">
      <h3 className="subtitle">Game code:</h3>
      <h1>{gameCode}</h1>
      <br />
      <div className="loading">
        <span>{partnerStatus}</span>
      </div>
      <footer className="footer">
        Send this code to your partner so they can join your game. The game will start automatically when they join.
      </footer>
    </div>
  );
};

export default CreateGame;
